T<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap >
      <v-flex sm12>
        <div class="col-md-12" style="float: right;">
          <v-dialog v-model="modalinstru.dialog" persistent max-width="100%">
            <v-btn color="primary" dark slot="activator">Novo Instrutor</v-btn>
            <v-card>
              <v-card-title>
                <span class="headline">Cadastro de Instrutores/Responsáveis</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                      label="Nome"
                      v-model="instrutor.name"
                      :rules="[rules.required]"
                      required autofocus></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                      label="Graduação"
                      v-model="instrutor.graduation"
                      :rules="[rules.required]"
                      maxlenght="35"
                      required autofocus></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                      label="Empesa"
                      v-model="instrutor.company"
                      :rules="[rules.required]"
                      maxlenght="35"
                      required autofocus></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <label>Imagem Assinatura:</label>
                      <input type="file" id="file" ref="file" accept="image/*" v-on:change="handleFileUploadCreated()"/>
                    </v-flex>  
                    <v-flex xs6>
                      <v-switch
                      label="Responsável"
                      v-model="instrutor.responsible"
                      ></v-switch> 
                    </v-flex>                                        
                    <v-flex xs6>
                      <v-switch
                      label="Instrutor"
                      v-model="instrutor.instructor"
                      ></v-switch>
                    </v-flex>  
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="modalinstru.dialog = false">Fechar</v-btn>
                <v-btn color="blue darken-1" flat @click="creatInstru()">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-flex>

      <!-- tabela de treinamentos -->  
      <v-flex lg12>
        <vue-good-table
        :columns="columns"
        :rows="instrutores"
        @on-row-click="onCellClick"
        @on-cell-click="onCellClick"
        :pagination-options="{
        enabled: true,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Registros por página',
        ofLabel: 'of',
        allLabel: 'Todos',
      }"
      styleClass="vgt-table bordered vgt-table condensed">
    </vue-good-table>
  </v-flex>

  <v-flex lg12>
    <v-card >
      <v-alert outline color="info" icon="info" :value="true">
        Clique sobre o instrutor para editar os dados
      </v-alert>
    </v-card> 
  </v-flex> 

  <v-flex>
    <v-dialog v-model="modaleditinstru.dialog" persistent max-width="100%">
      <v-card>
        <v-card-title>
          <span class="headline">Editando Instrutor</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
           <v-layout wrap>
            <v-flex xs12>
              <v-text-field
              label="Nome"
              v-model="dados_instru.name"
              :rules="[rules.required]"
              required autofocus></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
              label="Graduação"
              v-model="dados_instru.graduation"
              :rules="[rules.required]"
              maxlenght="35"
              required autofocus></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
              label="Empesa"
              v-model="dados_instru.company"
              :rules="[rules.required]"
              maxlenght="35"
              required autofocus></v-text-field>
            </v-flex>
            <v-flex xs12>
              <label>Imagem Assinatura:</label>
              <input type="file" id="file" ref="fileu" accept="image/*" v-on:change="handleFileUpload()"/>
            </v-flex>  
            <v-flex xs4>
              <v-switch
              label="Responsável"
              v-model="dados_instru.responsible"
              ></v-switch> 
            </v-flex>                                        
            <v-flex xs4>
              <v-switch
              label="Instrutor"
              v-model="dados_instru.instructor"
              ></v-switch>
            </v-flex>
            <v-flex xs4>
              <v-switch
              label="Ativado"
              v-model="dados_instru.active"
              ></v-switch>
            </v-flex>  
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="modaleditinstru.dialog = false">Fechar</v-btn>
        <v-btn color="blue darken-1" flat @click="updateInstru()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-flex>  

</v-layout>
</v-container>    

</template>

<script>
import {http, httpLogin} from '../../backend/vue-axios/axios';
import swal from 'sweetalert';
import { mapGetters } from 'vuex';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
export default {
  components: {
    quillEditor
  },
  data () {
    return {
      instrutores: [],
      dados_instru: [],
      columns: [
      {
        label: 'Nome',
        field: 'name',
        filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Informe o nome do usuário', // placeholder for filter input
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
          },
        },       
        {
          label: 'Instrutor',
          field: 'instructor',
          formatFn: this.formatFn,
        },        
        {
          label: 'Responsável',
          field: 'responsible',
          formatFn: this.formatFns,
        }
        ],

        instrutor: {
          name: '',
          company: '',
          graduation: '',
          responsible: false,
          instructor: false,
        },

        id_instru_ass: '',

        modalinstru: {
          dialog: false
        },          
        modaleditinstru: {
          dialog: false
        },        
        modalassinatura: {
          dialog: false
        },            
        rules: {
          required: (value) => !!value || 'Campo Obrigtório.',
          email: (value) => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || 'E-mail inválido.';
          } 
        },

        signature: '',
        file: '',
        showPreview: false,
        imagePreview: '',
        editorOption: {
          placeholder: 'Digite aqui o texto da sua assinatura',
          theme: 'bubble',
        },

      };
    },

    mounted () {
      this.buscaInstru();
    }, 

    methods: {


      onCellClick(params)
      {
        if(params.column.field == 'btnassi')
        {
          this.clickFuncAss(params)
        }else
        {
          this.clickTd(params)
        } 
        
      },

      handleFileUpload(){
        this.file = this.$refs.fileu.files[0];
        let reader  = new FileReader();
        reader.addEventListener("load", function () {
          this.showPreview = true;
          this.imagePreview = reader.result;
        }.bind(this), false);

        if( this.file ){
          if (this.file.type != "image/png") {
            swal({
              title: "Formato da assinatura inválido",
              text: "O formato deve ser .png",
              icon: "warning",
              timer: 2000,
              button: false

            });
          }
          if ( /\.(png)$/i.test( this.file.name ) ) {
            reader.readAsDataURL( this.file );
          }
        }
      },      

      handleFileUploadCreated(){
        this.file = this.$refs.file.files[0];
        let reader  = new FileReader();
        reader.addEventListener("load", function () {
          this.showPreview = true;
          this.imagePreview = reader.result;
        }.bind(this), false);

        if( this.file ){
           if (this.file.type != "image/png") {
            swal({
              title: "Formato da assinatura inválido",
              text: "O formato deve ser .png",
              icon: "warning",
              timer: 2000,
              button: false

            });
          }
          if ( /\.(png)$/i.test( this.file.name ) ) {
            reader.readAsDataURL( this.file );
          }
      }
    }, 


    upAssinaturasEdit(params)
    {  
      var data = new FormData();
      data.append('signature', this.file);
      http.post('instructors/'+ this.dados_instru.id +'/signature', data ,{

        headers: {
          'Content-Type': 'multipart/form-data; application/x-www-form-urlencoded; charset=UTF-8'
        }

      })
      .then(response => {
        this.$refs.file.value = null;
        this.$refs.fileInstru.value = null;
        this.modalassinatura.dialog = false;
      })
      .catch(e => {
        console.log(e);
      });
      this.modalassinatura.dialog = false
    },

    upAssinaturas()
    {

      let id_employed = this.id_instru_ass;
      var data = new FormData();
      data.append('signature', this.file);

      http.post('instructors/'+ id_employed +'/signature', data ,{

        headers: {
          'Content-Type': 'multipart/form-data; application/x-www-form-urlencoded; charset=UTF-8'
        }

      })
      .then(response => {
        this.$refs.file.value = null;
        this.$refs.fileInstru.value = null;
        this.modalassinatura.dialog = false;
      })
      .catch(e => {
        console.log(e);
      });
      this.modalassinatura.dialog = false
    },      

    formatFn: function(value) {

      if(value == 0){
        return 'Não';
      }else{
        return 'Sim';
      }
    },      
    formatFns: function(value) {

      if(value == 0){
        return 'Não';
      }else{
        return 'Sim';
      }
    },

    buscaInstru() {
      http.get('instructors')
      .then(response => {
       this.instrutores = response.data;
       for (var instructor in this.instrutores) {
        this.instrutores[instructor].btnassi = '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--outline v-btn--depressed v-btn--small theme--dark primary--text" style="position: relative;"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons">edit</i></div></button>'  
      }
    })
      .catch(error => {
        console.log()
      });
    },


    creatInstru() {
      http.post('instructors', {
        name: this.instrutor.name,
        instructor: this.instrutor.instructor,
        responsible: this.instrutor.responsible,
        graduation: this.instrutor.graduation,
        company: this.instrutor.company,

      })
      .then(response => {

        this.instrutores.push(response.data)
        this.id_instru_ass = response.data.id
        this.upAssinaturas()
        this.resetCreatInstructor()

        this.modalinstru.dialog = false;
        swal({
          title: "Instrutor!",
          text: "cadastrado com sucesso!",
          icon: "success",
          timer: 1000,
          button: false

        });
      })
      .catch(e => {
        console.log(e.response.status);  
      });

    },

    clickTd(params)
    {
      console.log(params);


      if(params.row.id == null || params.row.id == '')
      {
        swal({
          title: "Não",
          text: "foi possível editar o cadastro!",
          icon: "success",
          timer: 1000,
          button: false

        });
      }  
      this.modaleditinstru.dialog = true;

      let data = {
        id: params.row.id,
        name: params.row.name,
        instructor: params.row.instructor,
        responsible: params.row.responsible,
        company: params.row.company,
        active: params.row.active,
        graduation: params.row.graduation,
      }
      this.dados_instru = data;
    },

    clickFuncAss(params)
    {
      console.log(params);


      if(params.row.id == null || params.row.id == '')
      {
        swal({
          title: "Não",
          text: "foi possível editar o cadastro!",
          icon: "success",
          timer: 1000,
          button: false

        });
      }  
      this.modalassinatura.dialog = true;

      let data = {
        id: params.row.id,
        name: params.row.name,
        instructor: params.row.instructor,
        responsible: params.row.responsible,
        company: params.row.company,
        active: params.row.active,
        graduation: params.row.graduation,
      }
      this.dados_instru = data;
    },

    updateInstru()
    {
      http.put('instructors/' + this.dados_instru.id, {
        name: this.dados_instru.name,
        instructor: this.dados_instru.instructor,
        responsible: this.dados_instru.responsible,
        active: this.dados_instru.active,
        graduation: this.dados_instru.graduation,
        company: this.dados_instru.company,
      })
      .then(response => {

        this.buscaInstru();
        this.upAssinaturasEdit();
        swal({
          title: "Instrutor!",
          text: "atualizado com sucesso!",
          icon: "success",
          timer: 1000,
          button: false

        });

        this.modaleditinstru.dialog = false;
        this.dados_instru.push(response.data);
      })
      .catch(error => {
        console.log()
      });
    },

    fecharmodalAss()
    {
      this.$refs.file.value = null;
      this.$refs.fileInstru.value = null;
      this.modalassinatura.dialog = false;
    },

    resetCreatInstructor()
    {
      this.instrutor.name = ''
      this.instrutor.instructor = ''
      this.instrutor.responsible =''
      this.instrutor.graduation = ''
      this.instrutor.company = ''
    },




  }
};
</script>
<style scoped lang="css">
.custom-class{
  background-color: #b3d4fc!important
}
.quill{
  height : 120px;
  border: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/instrutores/Instrutores.vue